<script setup>
import {watch, onBeforeUnmount} from 'vue'
import {useVModel} from '@vueuse/core'
import { defineAsyncComponent } from 'vue';
import IconClose from "./icons/IconClose.vue";
// import SvgClose from '../assets/icons/close-interface-essential.svg'
// const SvgClose = defineAsyncComponent(() => import('@/assets/icons/close-interface-essential.svg'));

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: undefined,
    },
    size: {
        default: 'md',
        validator: (val) => [
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
        ].includes(val),
    },
    closeable: {
        type: Boolean,
        default: true,
    },
})

const opened = useVModel(props)

const disableScroll = () => {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.paddingRight = `${scrollBarWidth}px`
    document.body.style.overflow = 'hidden'
}

const enableScroll = () => {
    document.body.style.paddingRight = ''
    document.body.style.overflow = 'auto'
}

watch(opened, (value) => {
    if (value) {
        disableScroll()
    } else {
        enableScroll()
    }
})

if (opened.value) {
    disableScroll()
}

onBeforeUnmount(() => {
    enableScroll()
})
</script>

<script>
export default {
    inheritAttrs: false,
}
</script>

<template>
    <teleport
        to="body"
    >
        <transition
            enter-active-class="animate-fadeIn"
            leave-active-class="animate-fadeOut"
            appear
        >
            <div
                v-if="opened"
                class="fixed z-[9999] top-0 left-0 w-screen h-dvh bg-black/50
          flex items-center justify-center"
                data-test="modal"
                v-bind="$attrs"
                @mousedown.self="() => closeable ? opened = false : undefined"
            >
                <div
                    class="w-full p-7 relative bg-white rounded shadow-lg flex flex-col gap-6
            overflow-y-auto overflow-x-hidden max-h-[95vh]"
                    :class="{
            'max-w-md': size === 'xs',
            'max-w-lg': size === 'sm',
            'max-w-xl': size === 'md',
            'max-w-4xl': size === 'lg',
            'max-w-6xl': size === 'xl',
          }"
                    data-test="modal-box"
                >
                    <div>
                        <h1
                            v-if="title"
                            class="mb-6 text-lg font-medium"
                        >
                            {{ title }}
                        </h1>
                        <slot/>
                        <button
                            v-if="closeable"
                            class="absolute z-50 right-0 top-0 mr-7 mt-7"
                            data-test="modal-close"
                            @click="opened = false"
                        >
                            <IconClose
                                class="h-3.5 w-3.5"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </teleport>
</template>
